import React, { Component } from 'react';
import styled from 'styled-components';
import Link from '../Link';

import Checkbox from './Checkbox';

const Button = styled(Link)`
  color: ${p => p.theme.colors.primary};
  cursor: pointer;
  padding: 0;
  margin: 0;
  display: inline;
  border: none;
  text-decoration: underline;

  &:hover,
  &:active {
    text-decoration: none;
  }
`;

export default class PrivacyPolicyCheckbox extends Component {
  render() {
    const { name, value, checked, ...props } = this.props;

    return (
      <div>
        <Checkbox
          name={name}
          label={
            <span>
              Jeg bekrefter at jeg godkjenner{' '}
              <Button to="/personvernerklaering/">
                personvernerklæringen
              </Button>{' '}
              til denne nettsiden.
            </span>
          }
          checked={value || checked}
          value={value}
          {...props}
        />
      </div>
    );
  }
}
